<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('vendors') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.vendors"
            :options="vendors"
            class="w-full"
            :reduce="(el) => el.vendor_id"
            label="vendor_name"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('companies') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.companies"
            :options="companies"
            class="w-full"
            :reduce="(el) => el.company_id"
            label="company_name"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('periods') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.periods"
            :options="periods"
            class="w-full"
            :reduce="(el) => el.period_id"
            label="week_year"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('currencies') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.currencies"
            :options="currencies"
            class="w-full"
            :autoscroll="false"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <input-date
            :label="$t('date') | capitalize"
            v-model="filter.date"
          />
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import InputDate from '@/components/custom/InputDate'
import request from '../request.js'

export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.vendors
    },
  },
  data: () => ({
    vendors: [],
    companies: [],
    periods: [],
    categories: [],
    currencies: [],
    currencies: ['MXN', 'USD'],
    filter: {
      vendors: [],
      companies: [],
      periods: [],
      categories: [],
      currencies: [],
      date:''
    },
    defaultFilters: {
      vendors: [],
      companies: [],
      periods: [],
      categories: [],
      currencies: [],
      date:''
    },
    loading: {
      vendors: false,
      companies: false,
      periods: false,
      categories: false,
      currencies: false,
    },
  }),
  methods: {
    clear() {
      this.filter = Object.assign({}, this.defaultFilters)
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.filter = { ...this.value }
    },
    setFilter() {
      this.$emit('input', this.filter)
      this.$emit('search')
      this.close()
    },
    getCompanies() {
      request
        .getCompanies()
        .then((response) => {
          this.companies = [...response.data.companies]
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Attention2',
            text: 'Server Error',
          })
        })
    },
    getVendors() {
      request
        .getVendors()
        .then((response) => {
          this.vendors = [...response.data.vendors]
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Attention3',
            text: 'Server Error',
          })
        })
    },
    getPeriods() {
      request
        .getPeriods()
        .then((response) => {
          this.periods = [...response.data.periods]
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Attention4',
            text: 'Server Error',
          })
        })
    },
  },
  mixins: [loading],
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
  mounted() {
    this.getVendors()
    this.getCompanies()
    this.getPeriods()
  },
}
</script>

<style>
</style>
